import { render, staticRenderFns } from "./manufacter-model-form.vue?vue&type=template&id=a6241a24&scoped=true"
import script from "./manufacter-model-form.vue?vue&type=script&lang=ts"
export * from "./manufacter-model-form.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6241a24",
  null
  
)

export default component.exports